/* eslint-disable */
import HttpService from '../HttpService'

export default class LayoutService {
  constructor() {
    this._httpService = new HttpService('/sdi/layout/tag');
  }
  async FindAll() {
    return await this._httpService.get('');
  }
}
